import * as React from 'react'

import { LEAD_UNBOOKMARK_MUTATION, LEADS_FOR_PARENT_QUERY } from 'main/gql/lead'
import { User_user } from 'main/gql/user'
import { Mutation } from 'react-apollo'
import segment from 'util/analytics/segment'
import {
  LeadUnbookmark,
  LeadUnbookmarkVariables,
} from '../../../gql/lead/__generated__/LeadUnbookmark'
import Icon, { Style } from './Icon'

interface IProps {
  schoolId: number
  style: Style
  user: User_user | null
  onRequestOpenAuthModal: () => void
}

export default function Bookmarked(props: IProps) {
  const { schoolId, style, user, onRequestOpenAuthModal } = props

  return (
    <Mutation<LeadUnbookmark, LeadUnbookmarkVariables>
      mutation={LEAD_UNBOOKMARK_MUTATION}
      refetchQueries={[{ query: LEADS_FOR_PARENT_QUERY }]}
    >
      {mutate => (
        <Icon
          isBookmarked
          style={style}
          onClick={() => {
            if (user) {
              trackUnbookmarkEvent(schoolId)
              mutate({ variables: { schoolId } })
            } else {
              onRequestOpenAuthModal()
            }
          }}
        />
      )}
    </Mutation>
  )
}

function trackUnbookmarkEvent(schoolId: number) {
  segment.track('Program Removed From Favorites', { school_id: schoolId })
}
